import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownFolderItem } from './item/DropdownFolderItem';
import { Connect, PropsFromRedux } from './DropdownFolderListContainer';
import { DropdownSearchFolders } from './search/DropdownSearchFolders';
import styles from './dropdown_folder_list.module.scss';
import { withFolderDropdown } from '../../FoldersDropdownContext';
import {
  FoldersDropdownContextType,
  FolderSelectionType,
} from '../../foldersDropdown.types';
import { useStringSearch } from '../../../../components/hooks/useStringSearch';

type Props = {
  onFolderSelect: ({
    folder,
    searchActive,
  }: {
    folder: FolderSelectionType;
    searchActive: boolean;
  }) => void;
} & PropsFromRedux &
  FoldersDropdownContextType;

export const RawDropdownFolderList: FC<Props> = ({
  folders,
  onFolderSelect,
  saveSearchValue,
  searchValue,
}) => {
  const { handleChange, searchResults: foldersSearchResults } = useStringSearch(
    folders,
    'title',
    saveSearchValue,
  );

  const handleFolderSelection = (folder: FolderSelectionType) => {
    onFolderSelect({ folder, searchActive: !!searchValue });
  };

  const showSearchFolders = folders.length > 3; // display search bar if user has more than 4 folders

  return (
    <>
      {showSearchFolders && (
        <DropdownSearchFolders handleChange={handleChange} />
      )}
      <div className={styles.subtitle}>
        <FormattedMessage id="folders/dropdown/list/DropdownFolderList.tsx/2" />
      </div>
      <ul id="folders-list">
        {foldersSearchResults.length ? (
          foldersSearchResults.map((folder) => (
            <DropdownFolderItem
              key={folder.folderKey}
              folder={folder}
              onFolderSelect={handleFolderSelection}
            />
          ))
        ) : (
          <div className={styles.empty}>
            <FormattedMessage id="folders/dropdown/list/DropdownFolderList.tsx/1" />
          </div>
        )}
      </ul>
    </>
  );
};

export const DropdownFolderList = Connect(
  withFolderDropdown(RawDropdownFolderList),
);
